module.exports = __webpack_public_path__ + "media/images/icons/material/rss-428b16fae2ffe090d6d40d94a25869fe.svg";